export default "__VITE_ASSET__Dsw7bME___"